import { Section, SectionData, SectionTypes } from "./Section";

export { ColumnSection, ColumnSectionData };

type ColumnSectionData = {
  leftXPercent: number;
  rightXPercent: number;
} & SectionData;

class ColumnSection implements Section, ColumnSectionData {
  discriminator: SectionTypes = "COLUMN";
  leftXPercent: number;
  rightXPercent: number;

  constructor(data: ColumnSectionData) {
    this.leftXPercent = data.leftXPercent;
    this.rightXPercent = data.rightXPercent;
  }
  isConfigured(): boolean {
    return (
      this.leftXPercent !== 0 &&
      this.rightXPercent == 0 &&
      this.leftXPercent !== this.rightXPercent
    );
  }
  clear(): void {
    this.leftXPercent = 0;
    this.rightXPercent = 0;
  }
  toSectionData(): ColumnSectionData {
    return {
      leftXPercent: this.leftXPercent,
      rightXPercent: this.rightXPercent,
      discriminator: this.discriminator,
    };
  }
  getSectionType(): SectionTypes {
    return this.discriminator;
  }
  getSectionId(): string {
    return `${this.discriminator}-[${this.leftXPercent}]-[${this.rightXPercent}]`;
  }

  static createTest(rest: Partial<ColumnSectionData> = {}): ColumnSection {
    const data: ColumnSectionData = {
      leftXPercent: 0,
      rightXPercent: 0,
      discriminator: "COLUMN",
    };

    return new ColumnSection({
      ...data,
      ...rest,
    });
  }
}
